<template>
  <div>
    <el-button link type="primary" v-if="$checkPermission(permission)" @click="buttontap">{{ content }}</el-button>
    <p v-else>{{ content }}</p>
  </div>
</template>

<script>
export default {
  props: {
    permission: [Array],
    content: [String]
  },
  methods: {
    buttontap() {
      this.$emit('buttontap')
    }
  }
}
</script>

<style lang="less" scoped></style>
